import { SelectionMarketNameMap } from "../constants";
import { BANNED_REGEX, WHITELIST } from "../constants/inputs";

// this function generates a description for the favourite selection component
// it takes an array of markets and returns a string that is the description for the selection
// if the description is too long, it truncates and adds the number of markets that were not included
// and adds a "+ X more" to the end of the description where X is the number of markets that were not included
export const generateDescription = (markets) => {
  const description = markets.map((market) =>
    SelectionMarketNameMap.get(market)
  );

  let count = 0;
  let descriptionString = "";

  if (description.length === 1) {
    descriptionString = description[0];
  } else {
    description.forEach((market, index) => {
      if (count > 75) return;
      count += market.length;
      if (count > 75) descriptionString += `+ ${markets.length - index} more`;
      // if the last market, don't add a comma
      else if (index === markets.length - 1) descriptionString += market;
      else descriptionString += `${market}, `;
    });
  }

  return descriptionString;
};

export const generateFavouriteName = (type = "", favourites = []) => {
  const capitalizedType = type
    ? `${type.charAt(0).toUpperCase()}${type.slice(1)}`
    : "";
  const defaultName = `My Favourite ${capitalizedType}`.trim();

  if (favourites.length === 0) {
    return `${defaultName} 1`;
  }

  // Filter the favourites array to only include favourites of the same type
  const favouritesOfType = type
    ? favourites.filter(
        (favourite) =>
          favourite.type === type &&
          favourite.name.startsWith(defaultName) &&
          !isNaN(
            parseInt(favourite.name.split(` `)[defaultName.split(` `).length])
          )
      )
    : favourites;

  if (favouritesOfType.length === 0) {
    return `${defaultName} 1`;
  }

  // Find the highest number across all favorites of this type
  let highestNumber = 0;
  for (const favourite of favouritesOfType) {
    const nameParts = favourite.name.split(" ");
    const lastPart = nameParts[nameParts.length - 1];
    const num = parseInt(lastPart);
    if (!isNaN(num) && num > highestNumber) {
      highestNumber = num;
    }
  }

  // Increment the highest number found, or use 1 if no numbers were found
  const nextNumber = highestNumber > 0 ? highestNumber + 1 : 1;

  return `${defaultName} ${nextNumber}`;
};

export const isValidName = (input) => {
  const words = input.toUpperCase().split(/\s+/);
  for (const word of words) {
    if (WHITELIST.has(word)) {
      continue;
    }
    if (BANNED_REGEX.test(word)) {
      return false;
    }
  }
  return true;
};
